import { IUpdateColetaPrecoFornecedorUseCase } from "../../../presentation/useCases/update/update_coleta_preco_fornecedor_use_case";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * UpdateColetaPrecoFornecedorUseCase
 */

export class UpdateColetaPrecoFornecedorUseCase implements IUpdateColetaPrecoFornecedorUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async updateColetaPrecoFornecedor(
    idColetaPrecoFornecedor: number,
    imposto: number | null,
    frete: number | null,
    desconto: number | null,
    acrescimo: number | null,
    dataEntrega: Date | null,
    condicoesPagamento: string | null,
    observacoes: string | null,
    coletaProdutosServicos: IUpdateColetaPrecoFornecedorUseCase.Params[],
  ): Promise<void> {
    await this.repository.updateColetaPrecoFornecedor(
      idColetaPrecoFornecedor,
      imposto,
      frete,
      desconto,
      acrescimo,
      dataEntrega,
      condicoesPagamento,
      observacoes,
      coletaProdutosServicos,
    );
  }
}
